import { resolveControlPosition } from "../adapter/providerConstants.js";
// topo2 Button-Basis (Leiste + Buttons). Co-located: reist mit dem Consumer; Vite dedupliziert.

export function createMultiLocationControl({ onLeft, onRight, labelText = 'ALL'}) {
    // topo2-Leiste (horizontal): ◀ · Label · ▶. Die Legacy-Klasse `location-control-buttons` entfällt bewusst — sonst
    // überschriebe `.location-control-buttons button{height:20}` (basic.css) die topo2-Größe via Spezifität.
    const container = document.createElement('div');
    container.className = 'topo-multi-location topo2-btn-stack topo2-btn-stack--row';

    const makeNavButton = (chevron) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'topo2-btn topo2-btn--icon topo2-btn--outline';
        b.textContent = chevron;
        return b;
    };

    const leftBtn = makeNavButton('◀');

    const label = document.createElement('span');
    label.className = 'topo2-stack-label';
    label.textContent = labelText;

    const rightBtn = makeNavButton('▶');

    container.appendChild(leftBtn);
    container.appendChild(label);
    container.appendChild(rightBtn);

    leftBtn.addEventListener('click', () => onLeft?.(label));
    rightBtn.addEventListener('click', () => onRight?.(label));

    return container;
}

// Modul-Factory für den MapUiReconciler: Galerie-Navigation (◀ index/N ▶) als BOTTOM_CENTER-Control.
// Liefert null, solange ≤1 Galerie-Marker (noch nicht bereit → Reconciler baut beim nächsten Lauf). Verhalten (Cycle/Label)
// lebt hier im Control (Decision #4); Daten kommen über die api-Hooks (getGalleryMarkers/fitGalleryToIndex/allLabel).
// Handle { destroy } entfernt das Control wieder (ersetzt das tote removeMultiLocationControl).
export function createMultiLocationModule({ map, api, google, position }) {
    const markers = api.getGalleryMarkers ? api.getGalleryMarkers() : null;
    if (!markers || markers.length <= 1) { return null; }

    const allLabel = api.allLabel ? api.allLabel() : 'ALL';
    const container = createMultiLocationControl({ labelText: allLabel });
    const leftBtn = container.querySelector('button:first-of-type');
    const rightBtn = container.querySelector('button:last-of-type');
    const label = container.querySelector('span');

    let index = 0;
    const update = () => {
        if (api.fitGalleryToIndex) { api.fitGalleryToIndex(index === 0 ? null : index - 1); }
        label.textContent = index === 0 ? allLabel : `${index} / ${markers.length}`;
    };
    // Index-Mathematik 1:1 aus dem bisherigen ViewController-Aufbau übernommen (0 = ALLE, 1..N = einzelner Marker).
    leftBtn.addEventListener('click', () => { index = (index - 1 + markers.length + 1) % (markers.length + 1); update(); });
    rightBtn.addEventListener('click', () => { index = (index + 1 + markers.length + 1) % (markers.length + 1); update(); });

    const pos = position !== undefined ? position : resolveControlPosition(google, 'BOTTOM_CENTER');
    map.controls[pos].push(container);
    update();

    return {
        // Re-hängt das Control nur, falls die Controls geleert wurden (Tiles-Reload) — idempotent, OHNE Rebuild (Index bleibt).
        attach() {
            const arr = map.controls[pos];
            if (!arr) { return; }
            for (let i = 0; i < arr.getLength(); i++) {
                if (arr.getAt(i) === container) { return; }
            }
            arr.push(container);
        },
        destroy() {
            const arr = map.controls[pos];
            if (!arr) { return; }
            for (let i = arr.getLength() - 1; i >= 0; i--) {
                if (arr.getAt(i) === container) { arr.removeAt(i); }
            }
        }
    };
}
